import ProtectedRoutesTrustben from "./ProtectedRoutesTrustben";

export default ProtectedRoutesTrustben;
